import { pick, each, values, filter, extend, isUndefined, isNull, isEmpty, mapObject } from 'underscore';

const verifiedTrackingSettingAttachment = (ad) => {
  const verifiedTrackingSettings = ad.data.VerifiedTrackingSettings;
  if (isUndefined(verifiedTrackingSettings) || isNull(verifiedTrackingSettings)) {
    return {};
  }

  if (isEmpty(verifiedTrackingSettings)) {
    return { VerifiedTrackingData: '' };
  }
  const results = [];

  each(verifiedTrackingSettings, (setting) => {
    const result = [];
    mapObject(setting, (value, key) => {
      result.push({ Key: key, Value: value });
    });
    results.push(result);
  });

  return { VerifiedTrackingData: JSON.stringify(results) };
};

export const viewModelToModelForAd = ({ adsViewModel, campaign, adGroup }, isDeletedEntities = false) => {
  // parse the ads
  const adViewModel = [];

  each(adsViewModel, (ad) => {
    const finalUrl = ad.data.FinalUrls;
    const trackingUrlTemplate = ad.data.TrackingUrlTemplate;
    const finalUrlSuffix = ad.data.FinalUrlSuffix;
    const urlCustomParameters = ad.data.UrlCustomParameters;

    const video = ad.data.video ? JSON.stringify([{ id: ad.data.video.id, idString: ad.data.video.idString, subType: ad.data.video.type }]) : undefined;
    const image = ad.data.image ? JSON.stringify([{
      id: ad.data.image.id,
      subType: 'DisplayCreativeImage',
      targetWidth: ad.data.image.targetWidth,
      targetHeight: ad.data.image.targetHeight,
      cropX: ad.data.image.cropX,
      cropY: ad.data.image.cropY,
      cropWidth: ad.data.image.cropWidth,
      cropHeight: ad.data.image.cropHeight,
    }]) : undefined;

    const verifiedTrackingSettingAttachmentObj = verifiedTrackingSettingAttachment(ad);
    const impressionTrackingUrls = ad.data.ImpressionTrackingUrls ? { ImpressionTrackingUrls: ad.data.ImpressionTrackingUrls } : {};

    const fields = {
      'Client Id': `${ad.uid}`,
      FinalUrls: finalUrl,
      TrackingUrlTemplate: trackingUrlTemplate,
      FinalUrlSuffix: finalUrlSuffix,
      UrlCustomParameters: urlCustomParameters,
      Campaign: pick(campaign, 'Id'),
      AdGroup: pick(adGroup, 'Id'),
      ...verifiedTrackingSettingAttachmentObj,
      ...impressionTrackingUrls,
    };

    if (image) {
      extend(fields, { Images: image });
    }
    if (video) {
      extend(fields, { Videos: video });
    }

    if (ad.Id) {
      fields.Id = ad.Id;
    }

    if (isDeletedEntities) {
      fields.Status = 'Deleted';
    }

    if (ad.adSubType) {
      fields.AdSubType = ad.adSubType;
    }

    adViewModel.push(fields);
  });

  return adViewModel;
};

const adsWithIdsAttached = (savedAdsData, oldAdsData) => {
  const ads = [];

  each(oldAdsData, (ad, idx) => {
    // From API find the saved Item that has the client id same as the view model uid.
    // Once we have this item we try to patch the Id into the data model, so next time we know this will be an update scenario.
    const savedAdItem = filter(savedAdsData, sAd => sAd['Client Id'] === `${ad.uid}`);

    if (savedAdItem && savedAdItem[0] && savedAdItem[0].Id) {
      ads[idx] = { ...ad, Id: savedAdItem[0].Id };
    } else {
      ads[idx] = { ...ad, Id: undefined };
    }
  });

  return ads;
};

export const bulkModelToViewModelForAd = ({
  adsModel,
  originalAdsModel,
}) => {
  const processedAds = adsWithIdsAttached(adsModel, originalAdsModel.data);

  const adViewModel = {
    data: processedAds,
    isValid: true,
    isDirty: false,
    currentPageIndex: 1,
  };

  return adViewModel;
};


export const modelToViewModelForAd = ({
  adsModel,
}) => {
  const adsVideoModel = { ...adsModel };

  return adsVideoModel;
};

export const splitUpdateAndCreateAds = ({
  adsViewModel, oldAdsModel, campaign, adGroup,
}) => {
  const adIds = [];

  const adsToCreate = [];
  const adsToUpdate = [];
  const adsToDelete = [];

  each(values(adsViewModel.data), (ad) => {
    if (ad.data && (ad.data.video || ad.data.image)) {
      const adToSave = { ...ad };
      if (adsViewModel.adSubType) {
        adToSave.adSubType = adsViewModel.adSubType;
      }

      // check if the ad has ID
      if (adToSave.Id) {
        adsToUpdate.push(adToSave);

        // add the Ids of Ads that have already been saved to API
        // so that we can delete if the oldAdsModel contains more Ids
        adIds.push(adToSave.Id);
      } else {
        adsToCreate.push(adToSave);
      }
    }
  });

  if (oldAdsModel) {
    // get ids of the ads that are deleted (missing in adIds array)
    each(values(oldAdsModel.data), (oldAd) => {
      if (oldAd.Id && !adIds.includes(oldAd.Id)) {
        adsToDelete.push(oldAd);
      }
    });
  }

  const adsNeededToCreate = viewModelToModelForAd({ adsViewModel: adsToCreate, campaign, adGroup });

  const adsNeededToUpdate = [
    ...viewModelToModelForAd({ adsViewModel: adsToUpdate, campaign, adGroup }),
    ...viewModelToModelForAd({ adsViewModel: adsToDelete, campaign, adGroup }, true),
  ];

  return { adsNeededToCreate, adsNeededToUpdate };
};
